import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-product-dashboard-merchandize',
    templateUrl: './product-dashboard-merchandize.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDashboardMerchandizeComponent {

}